import { useEffect, useState } from "react";

export const BOTTOM_SHEET_EXIT_DURATION_MS = 300;

export const useDelayedUnmount = (shouldMount: boolean) => {
  const [isMounted, setIsMounted] = useState(shouldMount);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    if (shouldMount) {
      setIsLeaving(false);
      setIsMounted(true);
      return;
    }
    if (!isMounted) return;

    setIsLeaving(true);
    const timeoutId = setTimeout(() => {
      setIsMounted(false);
      setIsLeaving(false);
    }, BOTTOM_SHEET_EXIT_DURATION_MS);

    return () => clearTimeout(timeoutId);
  }, [shouldMount, isMounted, BOTTOM_SHEET_EXIT_DURATION_MS]);

  return { isMounted, isLeaving };
};
